import styled, { css } from 'styled-components';

// @ts-nocheck
var GuestRating = styled.div.withConfig({
  displayName: "GuestRatingstyle__GuestRating",
  componentId: "sc-fky0m2-0"
})(["align-items:center;display:inline-flex;flex-direction:column;", " ", ""], function (_ref) {
  var $hasOnClick = _ref.$hasOnClick;
  return $hasOnClick && css(["cursor:pointer;"]);
}, function (_ref2) {
  var $inlineLabel = _ref2.$inlineLabel;
  return $inlineLabel && css(["flex-direction:row;align-items:center;gap:var(--space-100);"]);
});
var RatingContainer = styled.div.withConfig({
  displayName: "GuestRatingstyle__RatingContainer",
  componentId: "sc-fky0m2-1"
})(["align-items:center;display:inline-flex;text-align:center;gap:var(--space-100);"]);
var Grade = styled.span.withConfig({
  displayName: "GuestRatingstyle__Grade",
  componentId: "sc-fky0m2-2"
})(["color:var(--color-text);font:var(--font-body-m);"]);
var Label = styled.div.withConfig({
  displayName: "GuestRatingstyle__Label",
  componentId: "sc-fky0m2-3"
})(["color:var(--color-text-subtle);"]);

export { Grade, GuestRating, Label, RatingContainer };
//# sourceMappingURL=GuestRating.style.js.map
